<template>
  <div class="panel-body">
    <fieldset v-if="seller" class="border">
      <legend class="border">ユーザ情報変更</legend>
      <japan-corporation-seller-info
        v-if="seller.countryCode === 'jp' && corporateIds.includes(parseInt(seller.corporateKbn))"
        :seller="seller"
      />
      <japan-individual-seller-info
        v-if="seller.countryCode === 'jp' && individualIds.includes(parseInt(seller.corporateKbn))"
        :seller="seller"
      />
      <china-corporation-seller-info
        v-if="seller.countryCode === 'cn' && corporateIds.includes(parseInt(seller.corporateKbn))"
        :seller="seller"
      />
      <china-individual-seller-info
        v-if="seller.countryCode === 'cn' && individualIds.includes(parseInt(seller.corporateKbn))"
        :seller="seller"
      />
      <div class="box-btn-renew text-right">
        <router-link :to="{path: '/update-register-info'}" class="btn btn-info btn-renew w-120 mr-t-10">更新</router-link>
      </div>
    </fieldset>
  </div>
</template>

<script>
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import JapanCorporationSellerInfo from '@/view/setting/userRegisteredInfo/JapanCorporation'
import JapanIndividualSellerInfo from '@/view/setting/userRegisteredInfo/JapanIndividual'
import ChinaCorporationSellerInfo from '@/view/setting/userRegisteredInfo/ChinaCorporation'
import ChinaIndividualSellerInfo from '@/view/setting/userRegisteredInfo/ChinaIndividual'

export default {
  components: {
    JapanCorporationSellerInfo,
    JapanIndividualSellerInfo,
    ChinaCorporationSellerInfo,
    ChinaIndividualSellerInfo
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      err: null,
      loader: null,
      seller: null,
      corporateIds: [1, 2, 3],
      individualIds: [4, 5]
    }
  },
  created () {
    this.getUserInfo()
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'user-info') {
      let logParams = {
        name: eventCode.settings.user_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  },
  methods: {
    async getUserInfo () {
      try {
        const response = await SettingService.getSellerInformation()
        if (Object.keys(response).length === 0) {
          this.$emit('checkData', false)
        } else {
          this.$emit('checkData', true)
          this.seller = response.seller
        }
      } catch (err) {
        this.err = err
      } finally {
        if (this.$route.params.tab === 'user-info') {
          this.$events.fire('done')
        }
      }
    }
  }
}
</script>

<style scoped>
.noti-page {
  padding: 10px;
  margin: 20px auto;
  color: red;
  border: 2px solid red;
  background-color: #fbe5d6;
}
/deep/ .box-seller-registered-info .item {
  display: flex;
  align-items: start;
  margin-bottom: 5px;
}
/deep/ .box-seller-registered-info .item .name {
  background-color: #008cc6;
  padding: 5px;
  min-width: 300px;
  width: 300px;
  height: auto;
  min-height: 34px;
  line-height: 24px;
  color: white;
  margin-right: 5px;
}
/deep/ .box-seller-registered-info .item .value {
  background-color: #eee;
  padding: 6px 12px;
  width: 100%;
  border: 1px solid #e4e5e7;
  border-radius: 4px;
  height: auto;
  min-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/UserInfo.vue